<template>
  <v-autocomplete
    ref="gruposPrestadoresSelect"
    v-model="formData.Prestadores"
    :items="PrestadoresNorm"
    :menu-props="{ maxHeight: '400px' }"
    :rules="formRules.requiredAutoComplete"
    label="Selecione um ou mais clientes"
    chips
    multiple
    outlined
    solo
    flat
    dense
    item-text="nome"
    item-value="id"
    class="GruposPrestadoresSelect"
    @blur="updateSelection(formData.Prestadores)"
    :search-input.sync="searchInput"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggleAllPrestadores">
        <v-list-item-content>
          <v-list-item-title>{{isAllSelected? 'NENHUM' : 'TODOS' }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="data">
         <v-chip
        v-if="!data.item.is_header && data.index<2 && !isAllSelected"
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        small

        @click:close="removePrestador(data.item)"
        label
        class="ma-1"
        >{{ data.item.nome }}</v-chip
      >    
        <span
          v-if="data.index == 1 && getSelectedLength> 1 && !isAllSelected"
          class="grey--text caption"
        >
          (+{{ (getSelectedLength==2 ?getSelectedLength-1 +' outro': getSelectedLength-1 + ' outros') }})
        </span>
        <span v-if="isAllSelected && data.index == 0">TODOS</span>
      </template>
    <!-- <template v-slot:selection="data">
      <v-chip
        v-show="!data.item.is_header"
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        small

        @click:close="removePrestador(data.item)"
        label
        class="ma-1"
        >{{ data.item.nome }}</v-chip
      >         
      // @click="data.select"
    </template> -->
    <template v-slot:item="data">
      <template v-if="(typeof data.item !== 'object')">
        <v-list-item-content v-text="data.item"></v-list-item-content>
      </template>
      <template v-if="data.item.is_header == true">
        <v-list-item ripple @click="toggleGrupos(data.item)">
          <v-list-item-content>
            <v-list-item-title
              style="font-weight: bold"
              v-text="data.item.nome"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item @click="togglePrestador(data.item)">
          <v-list-item-content>
            <v-list-item-title v-html="data.item.nome"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  props:{
    selecionados: Array,
    selectPrestadores: Function,
    validateField: Boolean
  },
  data() {
    return {
      formData: {
        Prestadores: [],
      },
      PrestadoresNorm: [],
      searchInput: null
    };
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() { 
        this.PrestadoresNorm = this.getGrupoPrestadoresList()
        this.$refs.gruposPrestadoresSelect.resetValidation()
      },
    },
    selecionados(val){
      if(this.isNew){
        this.formData.Prestadores = []
      } else if(!val.length) {
        let newList = []
          this.PrestadoresNorm
          .filter(el => !el.divider)
          .forEach(function (item) {
            newList.push(item.id);
          });
        this.formData.Prestadores = newList
      } else {
        this.formData.Prestadores = Array.from(val)
        let allGroups = this.PrestadoresNorm.filter(el => typeof el.id == "string")
        allGroups.forEach(group => {
          if(this.isAllSelectedByGroup(group.id, true) && !this.formData.Prestadores.includes(group.id)){
              this.formData.Prestadores.push(group.id)
          }
          })
      }
      this.$nextTick()
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
    }),
    ...mapGetters({
      getGrupoPrestadoresList:"permissions/getGrupoPrestadoresList"
    }),
    isAllSelected() {
      if(this.formData && this.formData.Prestadores){
        let selecao = this.formData.Prestadores
        let getOnlyPrestadores =  this.PrestadoresNorm
                                  .filter(el => !!el.grupo_id)
        let whithoutDividers = this.PrestadoresNorm.filter(el => !el.divider)
        if(selecao.find(el=> typeof el == "string")){
         return  selecao.length == whithoutDividers.length
        } else {
          return selecao.length == getOnlyPrestadores.length
        }
      } else {
        return false
      }
    },
    getSelectedLength(){
      return this.formData.Prestadores
              .filter(el => typeof el != "string")
              .length
    },
  },
  mounted() {
    this.PrestadoresNorm = this.getGrupoPrestadoresList()
  },
  methods: {
      isAllSelectedByGroup(grupo_id, grupo) {
        let desvio = grupo ? 0 : 1
        const allPrestadoresByGroup = this.PrestadoresNorm.reduce(
        (completeList, el) => {
          if (el.grupo_id == grupo_id) {
            completeList.push(el.id);
          }
          return completeList;
        },[])
        const allSelectedByGroup = this.formData.Prestadores.filter((prest) =>
          allPrestadoresByGroup.includes(prest)
        )
        return allPrestadoresByGroup.length == allSelectedByGroup.length + desvio;
    },
    removePrestador(item) {
      const index = this.formData.Prestadores.indexOf(item.id);
      if (index > -1) this.formData.Prestadores.splice(index, 1);

      const grupoInd = this.formData.Prestadores.indexOf(item.grupo_id);
      if (index > -1 && grupoInd > -1) {
        this.formData.Prestadores.splice(grupoInd, 1);
        this.$nextTick(() => {});
      }
    },
    toggleAllPrestadores() {
      let newList = [];
      this.$nextTick(() => {
        if (this.isAllSelected) {
          this.formData.Prestadores = [];
        } else {
          this.PrestadoresNorm
          .filter(el => !el.divider)
          .forEach(function (item) {
            newList.push(item.id);
          });
          this.formData.Prestadores = newList;
        }
      });
    },
    toggleGrupos(item) {
      let newList = [...this.formData.Prestadores];
      let newPrestadores = this.PrestadoresNorm.filter(
          (prest) => prest.grupo_id == item.id
        ).map((el) => el.id);
        let oldSelection = newList.filter((el) => newPrestadores.includes(el))
      if (item.is_header && !this.formData.Prestadores.includes(item.id)) {
        if (oldSelection.length) {
         let fewToInclude = newPrestadores.filter((prest) => !newList.includes(prest))
          newList.push(...fewToInclude)
        } else {
          newList.push(...newPrestadores)
          // newPrestadores.forEach( prest=>{ if (!prest.is_header)newList.push(prest) } )
        }
      } else {
        oldSelection.forEach((prest) => {
          let index = newList.indexOf(prest)
          newList.splice(index, 1)
        })
      }
      this.formData.Prestadores = newList
      this.$nextTick()
    },
    togglePrestador(item) {
      let index = this.formData.Prestadores.indexOf(item.id)
      let grupoInd = this.formData.Prestadores.indexOf(item.grupo_id)
      //  index > -1  está excluindo o prestador
      if (index > -1 && grupoInd > -1) {
        this.formData.Prestadores.splice(grupoInd, 1)
        this.$nextTick()
        return
      }
      //  index < 0  está adicionando o prestador
      if (index < 0 && this.isAllSelectedByGroup(item.grupo_id, false) && grupoInd == -1) {
        this.formData.Prestadores.push(item.grupo_id)
        this.$nextTick()
        return
      }

    },
    updateSelection(list){
      this.searchInput = null
      let newList = []
      if(!this.isAllSelected) {
        newList = list.filter(el => typeof el != "string" )
      }
      this.selectPrestadores(newList)
      this.$nextTick()
    }
  },
};
</script>